import React, { useEffect } from "react"
import { Spinner } from "reactstrap";

const Spinners = ({ setLoading , sCustomTop }: any) => {

    useEffect(() => {
        setLoading(setLoading);
        // setTimeout(() => {
        //     setLoading(false)
        // }, 1000)
    }, [setLoading]);
    
    return (
        <React.Fragment>
            <Spinner color="primary" className='position-absolute top-50 start-50' />
            <h5 className="text-center fw-semibold" style={{marginTop: sCustomTop ? sCustomTop : '70px'}}>
                Мэдээлэл уншиж байна
            </h5>
        </React.Fragment>
    )
}

export default Spinners;